import { useContext } from "react";
import { UserContext } from "../context/UserContext";

const useUser = () => {
  const { userState, userDispatch } = useContext(UserContext);
  return [userState, userDispatch];
};

export default useUser;
